export default "__VITE_ASSET__JeNUy3Wp__"